import React, { CSSProperties, FC, RefObject, MouseEventHandler, ReactNode } from 'react';
import cn from 'classnames';
import { Title, ITitleProps } from '../Title';
import { Link, ILinkProps } from '../Link';
import { Icon } from '../Icon';
import { Button } from '../Button';
require("./Banner.css");
var styles = {
  "Root": "Banner-module-Root_1Ln",
  "Title": "Banner-module-Title_1FH",
  "Description": "Banner-module-Description_QN2",
  "Link": "Banner-module-Link_373",
  "ButtonWrapper": "Banner-module-ButtonWrapper_10A",
  "rounded": "Banner-module-rounded_3Vl",
  "withShadow": "Banner-module-withShadow_33C",
  "centerContentPosition": "Banner-module-centerContentPosition_hJf",
  "Content": "Banner-module-Content_3uc",
  "Addon": "Banner-module-Addon_1iJ",
  "leftContentPosition": "Banner-module-leftContentPosition_1Et",
  "rightContentPosition": "Banner-module-rightContentPosition_Ci7",
  "Close": "Banner-module-Close_1-m",
  "CloseIcon": "Banner-module-CloseIcon_1eQ"
};
export const BannerContentPositions = {
  left: 'left',
  center: 'center',
  right: 'right'
};
export const Banner = ({
  rounded = true,
  title,
  titleTag = 'h4',
  description,
  linkText,
  linkHref,
  linkTarget = '_self',
  linkVariant = 'default',
  contentPosition = BannerContentPositions.center,
  button,
  addon,
  allowClose = false,
  withShadow = false,
  onClose,
  style,
  innerRef,
  controlRef,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    ref: innerRef || controlRef,
    className: cn(styles.Root, styles[`${contentPosition}ContentPosition`], {
      [styles.rounded]: rounded,
      [styles.withShadow]: withShadow
    }, className),
    style: style
  }, addon && /*#__PURE__*/React.createElement("div", {
    className: styles.Addon
  }, addon), /*#__PURE__*/React.createElement("div", {
    className: styles.Content
  }, title && /*#__PURE__*/React.createElement(Title, {
    tag: titleTag,
    className: styles.Title
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: styles.Description
  }, description), linkHref && /*#__PURE__*/React.createElement(Link, {
    href: linkHref,
    target: linkTarget,
    variant: linkVariant,
    className: styles.Link
  }, linkText), button && /*#__PURE__*/React.createElement("div", {
    className: styles.ButtonWrapper
  }, button)), allowClose && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: styles.Close,
    onClick: onClose,
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    className: styles.CloseIcon
  })));
};
if (process.env.NODE_ENV !== 'production') {
  Banner.displayName = 'Banner';
}